<div fxLayout="column" style="height: 100%">
    <app-topnavigation></app-topnavigation>
    <mat-sidenav-container fxFlex>
        <mat-sidenav #sidenav [(mode)]="mode" [(opened)]="opened" position="end"  (closedStart)="onClose()">
            <app-sidenavigation></app-sidenavigation>
        </mat-sidenav>
        <mat-sidenav-content fxFlex>
            <app-bcrumbsnav></app-bcrumbsnav>
            <router-outlet name="main"></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
    <span [fxShow]="showLoader" class="loading"></span>
    <ng-snotify></ng-snotify>
</div>